





































































import { Component, Emit, Vue, Prop } from 'vue-property-decorator';
import moment from 'moment';

import Datepicker from '@/components/datepicker/DatePicker.vue';
import ButtonPanel from '@/components/menu/panel/ButtonPanel.vue';
import IconButton from '@/components/atom/button/IconButton.vue';
import {loginModule} from '@/store/authentication/login';
import NormalButton from '@/components/atom/button/NormalButton.vue';
import AmountField from '@/components/atom/input/AmountField.vue';
import ConfirmDialog from '@/components/atom/dialog/ConfirmDialog.vue';
import AlertDialog from '@/components/atom/dialog/AlertDialog.vue';
import SenderSelector from '@/components/user/SenderSelector.vue';
import DepartmentSelector from '@/components/department/DepartmentSelector.vue';
import ToggleButtonField from '@/components/atom/input/ToggleButtonField.vue';
import 部署間移動修正チェッカー from '@/type/movement/records/modify/部署間移動修正チェッカー';
import {修正移動型} from '@/type/movement/records/modify/部署間移動修正削除';
import {移動入力在庫場所型} from '@/type/movement/records/register/部署間移動入力';
import 在庫場所選択型 from '@/type/movement/types/在庫場所選択型';

@Component({
  components: {
    ToggleButtonField,
    Datepicker,
    ButtonPanel,
    IconButton,
    NormalButton,
    AmountField,
    ConfirmDialog,
    AlertDialog,
    SenderSelector,
    DepartmentSelector,
  },
  filters: {
    日付フォーマット(date: Date): string | null {
      if (date === null) {
        return '';
      }
      return moment(date).format('YYYY/MM/DD');
    },
    数値フォーマット(value: number): string {
      if (value === null) {
        return '';
      }
      return value.toFixed(3);
    },
  },
})
export default class RegisterMovement extends Vue {
  // data
  @Prop()
  value!: 修正移動型;
  @Prop()
  rowIndex!: number;
  @Prop()
  department!: 在庫場所選択型;
  @Prop()
  movedepartment!: 移動入力在庫場所型;

  // computed
  get バラ管理である(): boolean {
    return loginModule.バラ管理である;
  }

  get 有効期限管理をする(): boolean {
    return loginModule.有効期限管理をする;
  }

  get 有効期限管理をしない(): boolean {
    return loginModule.有効期限管理をしない;
  }

  @Emit()
  clickRowSelect(): object {
    return {value: this.value};
  }

  @Emit()
  clickDeleteButton(): object {
    return {value: this.value};
  }

  確定対象トグルボタンが無効である(value: 修正移動型): boolean {
    return !this.修正あり(value);
  }

  修正あり(value: 修正移動型): boolean {
    if (value.移動.移動先部署コード !== value.修正移動先部署コード) return true;
    if (!moment(value.移動.移動年月日).isSame(value.修正移動年月日, 'day')) return true;
    if (value.移動.箱数 !== value.修正箱数) return true;
    if (value.移動.バラ数 !== value.修正バラ数) return true;
    return false;
  }

  修正不可である(value: 修正移動型): boolean {
    return value.移動.入力方法 === '入庫即移動';
  }

  確定対象ボタンを制御する(行番号: number): void {
    const current = this.value;
    if (this.修正あり(current)) {
      this.移動後在庫数チェック(行番号);
      current.確定対象 = true;
      return;
    }
    current.確定対象 = false;
  }

  private 移動後在庫数チェック(行番号: number): void {
    if (this.バラ管理である) {
      return this.バラ管理の移動後在庫数計算処理(行番号);
    } else {
      return this.箱管理の移動後在庫数計算処理(行番号);
    }
  }

  private 箱管理の移動後在庫数計算処理(行番号: number): void {
    this.value.修正前総移動数 = this.value.移動.箱数;
    this.value.再計算在庫数 = this.移動前の在庫数を計算する(行番号);
    this.value.修正後総移動数 = this.value.修正箱数;
    this.value.移動後在庫数 = this.移動後の在庫数を計算する(行番号);
  }

  private バラ管理の移動後在庫数計算処理(行番号: number): void {
    this.value.修正前箱数バラ換算 = this.修正前の箱数をバラ数に換算する(行番号);
    this.value.修正前総移動数 = this.修正前の移動バラ数を合計する(行番号);
    this.value.再計算在庫数 = this.移動前の在庫数を計算する(行番号);
    this.value.修正後箱数バラ換算 = this.修正後の箱数をバラ数に換算する(行番号);
    this.value.修正後総移動数 = this.修正後の移動バラ数を合計する(行番号);
    this.value.移動後在庫数 = this.移動後の在庫数を計算する(行番号);
  }

  private 移動前の在庫数を計算する(行番号: number): any {
    return this.value.移動.現在庫数 + this.value.修正前総移動数;
  }

  private 修正前の箱数をバラ数に換算する(行番号: number): any {
    if (this.value.移動.包装単位数 === null || this.value.移動.包装単位数 === 0) {
      return 0;
    }
    if (this.value.移動.バラ単位区分 === '包装単位') {
      return this.value.移動.箱数 * this.value.移動.入数;
    } else {
      return this.value.修正箱数 * (this.value.移動.入数 / this.value.移動.包装単位数);
    }
  }

  private 修正前の移動バラ数を合計する(行番号: number): any {
    return this.value.修正前箱数バラ換算 + this.value.移動.バラ数;
  }

  private 修正後の箱数をバラ数に換算する(行番号: number): any {
    if (this.value.移動.包装単位数 === null || this.value.移動.包装単位数 === 0) {
      return 0;
    }
    if (this.value.移動.バラ単位区分 === '包装単位') {
      return this.value.修正箱数 * this.value.移動.入数;
    } else {
      return this.value.移動.箱数 * (this.value.移動.入数 / this.value.移動.包装単位数);
    }
  }

  private 修正後の移動バラ数を合計する(行番号: number): any {
    return this.value.修正後箱数バラ換算 + this.value.修正バラ数;
  }

  private 移動後の在庫数を計算する(行番号: number): any {
    return Math.round((this.value.再計算在庫数 - this.value.修正後総移動数) * 1000) / 1000;
  }


  get 移動日付Style(): object {
    return {alert: this.入力エラーが存在する('修正移動年月日')};
  }

  private 入力エラーが存在する(項目名: string): boolean {
    const checker = new 部署間移動修正チェッカー();
    checker.validate(this.value, this.バラ管理である, this.department);
    return checker.hasError(項目名);
  }
}
